export default __webpack_public_path__ + "static/media/login-call.81d0eb2b.svg";